// extracted by mini-css-extract-plugin
export var noSpinners = "_sn-6";
export var percentageInput = "_sn-7";
export var variantColor1 = "_sn-0";
export var variantColor2 = "_sn-1";
export var variantColor3 = "_sn-2";
export var variantColor4 = "_sn-3";
export var variantColor5 = "_sn-4";
export var variantColor6 = "_sn-5";